import { StateUpdatedEvent } from "ag-grid-community";

export const agGridDisabledSourcesForStateUpdate: StateUpdatedEvent["sources"] =
  [
    "gridInitializing",
    "focusedCell",
    "scroll",
    "rowSelection",
    "rowGroupExpansion",
    "pagination",
  ];

export const agGridFooterColId = "rowGroupFooter";
export const agGridGrandFooterColId = `${agGridFooterColId}_ROOT_NODE_ID`;
export const agGridAutoGroupColId = "ag-Grid-AutoColumn";
